export interface ClienteOptionsActions {
    canEdit: boolean;
    canPrintFichaCadastral: boolean;
    canImportOneErp_v1: boolean;
    canImportOneErp: boolean;

    // Negócio
    canInsertNegocio: boolean;

    // Análise Financeira
    canIniciarAnaliseFinanceira: boolean;
    canCancelarIniciarAnaliseFinanceira: boolean;
    canConcluirAnaliseFinanceira: boolean;
    canCancelarConcluirAnaliseFinanceira: boolean;
    canRevisarAnaliseFinanceira: boolean;

    // Congelar
    canCongelar: boolean;
    canDescongelar: boolean;

    // Pré-Baixar
    canPreBaixar: boolean;
    canEditPreBaixa: boolean;
    canCancelarPreBaixa: boolean;

    // Baixar
    canBaixar: boolean;
    canEditBaixa: boolean;
    canCancelarBaixa: boolean;
}

export class ClienteTableOptions implements ClienteOptionsActions {
    canEdit: boolean;
    canPrintFichaCadastral: boolean;
    canImportOneErp_v1: boolean;
    canImportOneErp: boolean;

    // Negócio
    canInsertNegocio: boolean;

    // Análise Financeira
    canIniciarAnaliseFinanceira: boolean;
    canCancelarIniciarAnaliseFinanceira: boolean;
    canConcluirAnaliseFinanceira: boolean;
    canCancelarConcluirAnaliseFinanceira: boolean;
    canRevisarAnaliseFinanceira: boolean;

    // Congelar
    canCongelar: boolean;
    canDescongelar: boolean;

    // Pré-Baixar
    canPreBaixar: boolean;
    canEditPreBaixa: boolean;
    canCancelarPreBaixa: boolean;

    // Baixar
    canBaixar: boolean;
    canEditBaixa: boolean;
    canCancelarBaixa: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canEdit ||
                this.canPrintFichaCadastral ||
                this.canImportOneErp_v1 ||
                this.canImportOneErp ||
                this.canInsertNegocio ||
                this.hasCongelamentoOptions() ||
                this.hasAnyOptionAnaliseFinanceira() ||
                this.hasPreBaixarOptions() ||
                this.hasBaixarOptions();
    }

     /** Verifica se possui alguma opção habilitada da análise financeira */
     hasAnyOptionAnaliseFinanceira(): boolean {
        return this.canIniciarAnaliseFinanceira ||
            this.canCancelarIniciarAnaliseFinanceira ||
            this.canConcluirAnaliseFinanceira ||
            this.canCancelarConcluirAnaliseFinanceira ||
            this.canRevisarAnaliseFinanceira;
    }

    /** Verifica se possui alguma opção referente ao congelamento */
    hasCongelamentoOptions(): boolean {
    return this.canCongelar ||
            this.canDescongelar;
    }

    /** Verifica se possui alguma opção referente a Pré-Baixa */
    hasPreBaixarOptions(): boolean {
        return this.canPreBaixar ||
                this.canEditPreBaixa ||
                this.canCancelarPreBaixa;
    }

    /** Verifica se possui alguma opção referente a Baixa do cliente */
    hasBaixarOptions(): boolean {
        return this.canBaixar ||
                this.canEditBaixa ||
                this.canCancelarBaixa;
    }
}
